export const SITE_WORKING_CONDITION_ACQUISITION_PILOTS_TABLE_FRENCH_LOCALE = {
  headers: {
    csId: "Pilote Cs Id",
    hwId: "Pilote Hw Id",
    name: "Nom",
    lastSyncDate: "Date de dernière sync.",
    serialNumber: "Numéro de série",
    softwareVersion: "Version logicielle",
  },
  empty: "Aucun pilote",
};
